import React, {useEffect, useReducer} from "react";
import "./filtered-login-info.styles.scss";
// import OrderHistory from "../order-history/order-history.component";
import SelectList from "../../commons/form-inputs/select-list/select-list.component";
import DualSetDataTable from "../dual-set-data-table/dual-set-data-table.component";
import OrderDataTable from "../order-data-table/order-data-table.component";
import SubmitRemoteModelingForm from "../../commons/forms/submit-remote-modeling/submit-remote-modeling.component";
import TrainingDataTable from "../training-certificates-data-table/training-certificates.component";

import {
    completedTabNames,
    eLearningCategories,
    eLearningItems,
    oldOrderHistory,
    orderCategories,
    orderTableItems,
    queuedTabNames,
    softwareCategories,
    softwareTableItems,
    trainingCategories,
    trainingTableItems,
    webinarCategories,
} from "./filtered-login-info.data";
import ElearningTableComponent from "../e-learning-table/elearning-table.component";
import WebinarTableComponent from "../webinar-table/webinar-table.component";
import SoftwareAndDataDownloads from "../software-and-data-downloads/software-and-data-downloads";
import {useSelector} from "react-redux";

const initialState = {
    orderHistory: {
        action: "order-history",
        title: "My Order History",
        active: true,
    },
    downloadTable: {
        action: "software-download",
        title: "Software Downloads",
        active: false,
    },
    jobStatus: {
        action: "job-status",
        title: "Remote Modeling Job Status",
        active: false,
    },
    submitJob: {
        action: "submit-job",
        title: "Submit New Remote Modeling",
        active: false,
    },
    webinar: {
        action: "webinar",
        title: "On Demand Webinar",
        active: false,
    },
    eLearning: {
        action: "eLearning",
        title: "e-Learning",
        active: false,
    },
    trainingCertificates: {
        action: "training-certificates",
        title: "Training Certificates",
        active: false,
    },
};

const resetState = {
    ...initialState,
    orderHistory: {
        ...initialState.orderHistory,
        active: false,
    },
    // orderHistory2: {
    //   ...initialState.orderHistory2,
    //   active: false,
    // },
    // trainingCertificates: {
    //   ...initialState.trainingCertificates,
    //   active: false,
    // },
};

const reducer = (state, action) => {
    localStorage.setItem("lastActiveTab", action.type)
    switch (action.type) {
        case "software-download":
            return {
                ...resetState,
                downloadTable: {
                    ...resetState.downloadTable,
                    active: true,
                },
            };
        case "order-history":
            return {
                ...resetState,
                orderHistory: {
                    ...resetState.orderHistory,
                    active: true,
                },
            };
        // case "order-history":
        //   return {
        //     ...resetState,
        //     orderHistory: {
        //       ...resetState.orderHistory,
        //       active: true,
        //     },
        //   };

        case "job-status":
            return {
                ...resetState,
                jobStatus: {
                    ...resetState.jobStatus,
                    active: true,
                },
            };
        case "training-certificates":
            return {
                ...resetState,
                trainingCertificates: {
                    ...resetState.trainingCertificates,
                    active: true,
                },
            };
        case "submit-job":
            return {
                ...resetState,
                submitJob: {
                    ...resetState.submitJob,
                    active: true,
                },
            };
        case "webinar":
            return {
                ...resetState,
                webinar: {
                    ...resetState.webinar,
                    active: true,
                },
            };
        case "eLearning":
            return {
                ...resetState,
                eLearning: {
                    ...resetState.eLearning,
                    active: true,
                },
            };
        default:
            return {...initialState};
    }
};

function FilteredLoginInfo() {
    // const titles = [
    //   "Software & Data Downloads",
    //   "My Order History",
    //   // "My Order History",
    //   "Remote Modeling Job Status",
    //   "Training Certificates",
    //   "Submit New Remote Modeling",
    // ];

    const [state, dispatch] = useReducer(reducer, initialState);

    // const [data, setData] = useState(state);

    // function filterContent(activeSection) {
    //   let newData = data.map((group) => {
    //     if (activeSection === group.section) {
    //       group.active = true;
    //     } else {
    //       group.active = false;
    //     }
    //     return group;
    //   });

    //   setData(newData);
    // }

    const hasBRMSKey = useSelector(({client}) => client.brmsKey);

    useEffect(() => {
        if (localStorage.getItem("lastActiveTab")) {
            dispatch({type: localStorage.getItem("lastActiveTab")})
        }
    }, [])

    return (
        <div className="filtered-login-info">
            <div className="filters md-up-module-spacer-bottom trinity-container">
                <SelectList
                    className="d-xs-block d-sm-none d-md-none d-lg-none d-xl-none"
                    defaultText="— My Account —"
                    onChange={(e) => dispatch({type: e.target.value})}>
                    {
                        Object.entries(state).map(([actionTitle, dataObj]) => (
                            <option value={dataObj.action} className={`filter ${dataObj.active ? "active" : ""}`}>
                                {dataObj.title}
                            </option>
                        ))
                    }
                </SelectList>

                <hr className="mobile-seperator d-md-none"/>

                <div className="title-filters">
                    {
                        Object.entries(state).map(([actionTitle, dataObj]) => {
                                return (
                                    <h3 onClick={() => dispatch({type: dataObj.action})}
                                        className={`filter ${dataObj.active ? "active" : ""}`}>
                                        {dataObj.title}
                                    </h3>
                                )
                            }
                        )}
                </div>
            </div>

            <div className="displays">
                {state.downloadTable.active && (
                    <SoftwareAndDataDownloads
                        title={"Software & Data Downloads"}
                        filterOne={"Software"}
                        tableItemsOne={softwareTableItems}
                        categoriesOne={softwareCategories}
                    />
                )}
                {state.orderHistory.active && (
                    <OrderDataTable
                        filterOne={"Order History"}
                        tableItemsOne={orderTableItems}
                        categoriesOne={orderCategories}
                        filterTwo={"Order History (before 11/20/2020)"}
                        categoriesTwo={oldOrderHistory}
                        tableItemsTwo={orderTableItems}
                    />
                )}
                {/* {state.orderHistory.active && <OrderHistory />} */}
                {state.jobStatus.active && (
                    <DualSetDataTable
                        title={"Jobs & Results"}
                        filterOne={"My Results"}
                        // tableItemsOne={jobsTableItems}
                        categoriesOne={completedTabNames}
                        tableOneColumnWidth={"180px"}
                        filterTwo={"My Jobs"}
                        // tableItemsTwo={resultsTableItems}
                        categoriesTwo={queuedTabNames}
                        tableTwoColumnWidth={"210px"}
                    />
                )}
                {state.webinar.active && (
                    <div>
                        <WebinarTableComponent
                            title={"Webinar"}
                            filterOne={"Paid"}
                            filterTwo={"Free"}
                            filterThree={"Paid (before 11/20/2020)"}
                            filterFour={"Free (before 11/20/2020)"}
                            categoriesOne={webinarCategories}
                            tableItemsOne={eLearningItems}
                            tableItemsTwo={eLearningItems}
                            categoriesTwo={webinarCategories}
                        />
                    </div>
                )}
                {state.eLearning.active && (
                    <div>
                        <ElearningTableComponent
                            title={"eLearning"}
                            filterOne={"eLearning"}
                            tableItemsOne={eLearningItems}
                            categoriesOne={eLearningCategories}
                            filterTwo={"eLearning Orders (before 11/20/2020)"}
                            categoriesTwo={eLearningCategories}
                        />
                    </div>
                )}
                {state.submitJob.active && (
                    <div>
                        <SubmitRemoteModelingForm hasRemoteModelingAccount={typeof hasBRMSKey === "object"}
                                                  onFormSubmit={() => dispatch({type: "job-status"})}/>
                    </div>
                )}
                {state.trainingCertificates.active && (
                    <div>
                        <TrainingDataTable
                            filterOne={"Training Certificates"}
                            tableItemsOne={trainingTableItems}
                            categoriesOne={trainingCategories}
                            tableOneColumnWidth={"210px"}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default FilteredLoginInfo;
